import React from 'react';
import pricingData from '../data/pricing';
import { Check, Clock, Users } from 'lucide-react';
import './Prices.css';

const Prices = () => {
    return (
        <div className="prices-page">
            <div className="prices-header">
                <h1>Tarifas</h1>
                <p>Precios transparentes y competitivos para tu salud.</p>
            </div>

            <div className="container">
                <div className="pricing-grid">
                    {Object.values(pricingData).map((category, index) => (
                        <div key={index} className="pricing-category">
                            <div className="category-header">
                                <span className="category-icon">{category.icon}</span>
                                <h2>{category.title}</h2>
                            </div>

                            {category.description && (
                                <div className="category-description">
                                    <p>{category.description}</p>
                                </div>
                            )}

                            <div className="services-list">
                                {category.services.map((service, idx) => (
                                    <div
                                        key={idx}
                                        className={`service-item ${service.highlight ? 'highlighted' : ''}`}
                                    >
                                        <div className="service-info">
                                            <h3>{service.name}</h3>
                                            <div className="service-meta">
                                                {service.duration && (
                                                    <span className="service-duration">
                                                        <Clock size={14} />
                                                        {service.duration}
                                                    </span>
                                                )}
                                                {service.group && (
                                                    <span className="service-group">
                                                        <Users size={14} />
                                                        {service.group}
                                                    </span>
                                                )}
                                            </div>
                                            {service.note && (
                                                <p className="service-note">{service.note}</p>
                                            )}
                                        </div>
                                        <div className="service-price">
                                            {service.price}
                                        </div>
                                        {service.highlight && (
                                            <div className="highlight-badge">
                                                <Check size={16} />
                                                Ahorro
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="pricing-footer">
                    <div className="info-box">
                        <h3>💳 Formas de pago</h3>
                        <p>Aceptamos efectivo, tarjeta y transferencia bancaria.</p>
                    </div>
                    <div className="info-box">
                        <h3>📅 Cancelaciones</h3>
                        <p>Avisa con 24h de antelación para evitar cargos.</p>
                    </div>
                    <div className="info-box">
                        <h3>🎁 Bonos</h3>
                        <p>Los bonos tienen validez de 6 meses desde su compra.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Prices;
